// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"6722881a","666":"54c2dc2f","818":"bb1824cf","831":"7ad23ebf"}[chunkId] + ".chunk.js";
};